/** @jsxImportSource @emotion/react */

import { NotiMarque } from "components/desktop/NotiMarque";
import CategoryGameSwiper from "components/mobile/CategoryGameSwiper";
import FuncUser from "components/mobile/FuncUser";
import { dataCasinoMobile } from "contants/game/mobile/contents/casino";
import handleLoginGame from "helpers/handleLoginGame";
import { useAppDispatch } from "hooks/app-hook";
import { SwiperBanner } from "pages/desktop/HomePage/SwiperBanner/SwiperPagination";
import { useSelector } from "react-redux";
import { selectUsername } from "store/auth";

import { CasinoGameMobileStyle } from "./style.index";

const CasinoGameMobile = () => {
  const username = useSelector(selectUsername);
  const dispatch = useAppDispatch();
  return (
    <div css={CasinoGameMobileStyle.wrapper}>
      <NotiMarque />
      <SwiperBanner />
      <FuncUser />
      <CategoryGameSwiper />
      <div css={CasinoGameMobileStyle.mainContent}>
        {dataCasinoMobile.map((items, index) => (
          <div
            onClick={() => {
              handleLoginGame(items, username, dispatch);
            }}
            key={index}
            css={CasinoGameMobileStyle.item}
          >
            <img src={items.picture} alt="" />
            <span>{items.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CasinoGameMobile;
